/**
 * @flow
 * @relayHash 1dd7ad79342ab9ab7b8cac58a3757eb2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteWuploadInput = {
  clientMutationId?: ?string,
  id: string,
};
export type WorkspacesComponent_deleteWuploadMutationVariables = {|
  input: DeleteWuploadInput
|};
export type WorkspacesComponent_deleteWuploadMutationResponse = {|
  +deleteWupload: ?{|
    +deletedWuploadId: ?string
  |}
|};
export type WorkspacesComponent_deleteWuploadMutation = {|
  variables: WorkspacesComponent_deleteWuploadMutationVariables,
  response: WorkspacesComponent_deleteWuploadMutationResponse,
|};
*/


/*
mutation WorkspacesComponent_deleteWuploadMutation(
  $input: DeleteWuploadInput!
) {
  deleteWupload(input: $input) {
    deletedWuploadId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteWuploadInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteWupload",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeleteWuploadInput!"
      }
    ],
    "concreteType": "DeleteWuploadPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedWuploadId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "WorkspacesComponent_deleteWuploadMutation",
  "id": null,
  "text": "mutation WorkspacesComponent_deleteWuploadMutation(\n  $input: DeleteWuploadInput!\n) {\n  deleteWupload(input: $input) {\n    deletedWuploadId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "WorkspacesComponent_deleteWuploadMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "WorkspacesComponent_deleteWuploadMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0b7031487f14a79fda8b50baa7efaeba';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/Workspace/__generated__/WorkspacesComponent_deleteWuploadMutation.graphql.js